<template>
  <div class="container-fluid">
    <loading :active.sync="isLoading" loader="dots"></loading>

    <div class="function-card">
      <button
        type="button"
        class="btn btn-primary"
        @click="openRoomModal({ action: 'addRoom' })"
      >
        新增
      </button>
    </div>

    <div class="yahome-table-wrap">
      <VueBootstrap4Table :rows="roomList" :columns="columns" :config="config">
        <template slot="status" slot-scope="props">
          <svg
            v-if="props.row.IsEnabled"
            width="25"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
          >
            <path
              d="M 400.6 173.4 c 12.5 12.5 12.5 32.8 0 45.3 l -188 188 c -12.5 12.5 -32.8 12.5 -45.3 0 l -100 -100 c -12.5 -12.5 -12.5 -32.8 0 -45.3 s 32.8 -12.5 45.3 0 L 192 338.7 L 355 173 c 12.5 -12.5 32.8 -12.5 45.3 0 z"
            />
          </svg>

          <svg
            v-if="!props.row.IsEnabled"
            width="15"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 320 512"
          >
            <path
              d="M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z"
            />
          </svg>
        </template>
        <template slot="edit" slot-scope="props">
          <button
            type="button"
            class="btn btn-info btn-sm"
            @click="openRoomModal({ action: 'editRoom', data: props.row })"
          >
            編輯
          </button>
        </template>
        <template slot="delete" slot-scope="props">
          <button
            type="button"
            class="btn btn-danger btn-sm"
            @click="openDeleteRoomModal(props.row)"
          >
            刪除
          </button>
        </template>
        <template slot="empty-results"> 暫無資料 </template>
      </VueBootstrap4Table>
    </div>

    <!-- 新增 & 編輯 Modal -->
    <div
      class="modal fade"
      id="roomModal"
      tabindex="-1"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <ValidationObserver
          ref="roomModal"
          class="modal-content"
          v-slot="{ handleSubmit, reset }"
        >
          <form @reset.prevent="reset">
            <div class="modal-header">
              <span v-if="isAddRoom">新增面談室</span>
              <span v-else>編輯面談室</span>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <label for="roomName">
                    <span class="mark">*</span>
                    面談室名稱
                  </label>
                  <input
                    type="text"
                    id="roomName"
                    class="form-control"
                    v-model.trim="roomModal.Name"
                  />
                  <span class="text-danger">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
              <div class="form-group">
                <label for="roomName"> 狀態 </label>
                <el-switch
                  style="display: block"
                  v-model="roomModal.IsEnabled"
                  active-color="#409eff"
                  inactive-color="#ccc"
                  active-text="啟用"
                  inactive-text="未啟用"
                >
                </el-switch>
              </div>
            </div>
            <div class="modal-footer">
              <button type="reset" class="btn btn-secondary" data-dismiss="modal">
                {{ i18n("Buttons.Cancel") }}
              </button>
              <button
                type="button"
                class="btn btn-success"
                @click="handleSubmit(saveRoom)"
              >
                {{ i18n("Buttons.Save") }}
              </button>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>

    <!--刪除 Modal -->
    <div
      class="modal fade"
      id="delModal"
      tabindex="-1"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <span>刪除面談室</span>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <span>確定刪除<span style="color:#ff0000;">{{roomModal.Name}}</span>？</span>
            </div>
          </div>
          <div class="modal-footer">
            <button type="reset" class="btn btn-secondary" data-dismiss="modal">
              {{ i18n("Buttons.Cancel") }}
            </button>
            <button type="button" class="btn btn-danger" @click="delRoom">
              {{ i18n("Buttons.Delete") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global $ */
import moment from "moment";
import { config } from "@/components/back/table_config.js";
import { mapGetters } from "vuex";

export default {
  name: "RoomScheduleSetting",

  data() {
    return {
      // compositionstart & compositionend
      is_composing: false,

      isAddRoom: false,
      roomName: null,
      lock: true,

      roomList: [],
      roomModal: {},
      columns: [
        {
          label: "面談室名稱",
          name: "Name",
        },
        {
          label: "啟用",
          name: "IsEnabled",
          slot_name: "status",
        },

        {
          label: "",
          name: "edit",
          slot_name: "edit",
        },
        {
          label: "",
          name: "delete",
          slot_name: "delete",
        },
      ],
      config,
    };
  },

  methods: {
    openRoomModal({ action, data }) {
      let temp = null
      if(data){
        temp = JSON.parse(JSON.stringify(data));
      }
      
      switch (action) {
        case "addRoom":
          this.roomModal = {
            Name: null,
            IsEnabled: true,
          };
          this.isAddRoom = true;
          break;
        case "editRoom":
          this.roomModal = temp;
          this.isAddRoom = false;
          break;
      }
      this.$refs.roomModal.reset();
      $("#roomModal").modal("show");
    },

    openDeleteRoomModal(row){
      const vm = this;
      vm.roomModal={...row}
      $("#delModal").modal("show");
    },

    saveRoom() {
      const vm = this;
      vm.$store.dispatch("updateLoading", true);
      if (vm.isAddRoom) {
        vm.$api.InterviewSch.createRoom(vm.roomModal)
          .then((response) => {
            if (response.data.ErrorMessage) {
              this.$notify({
                message: response.data.ErrorMessage,
                type: "error",
              });
            } else {              
              $("#roomModal").modal("hide");
              vm.$notify({
                message: "新增成功",
                type: "success",
              });
              vm.getRoomList();
            }
            vm.$store.dispatch("updateLoading", false);
          })
          .catch((error) => {
            vm.$store.dispatch("updateLoading", false);
            this.$notify({
              message: error.response.data.ErrorMessage,
              type: "error",
            });
          });
      } else {
        vm.$api.InterviewSch.editRoom(vm.roomModal)
          .then((response) => {
            if (response.data.ErrorMessage) {
              this.$notify({
                message: response.data.ErrorMessage,
                type: "error",
              });
            } else {
              $("#roomModal").modal("hide");
              vm.$notify({
                message: "編輯成功",
                type: "success",
              });
              vm.getRoomList();
            }
            vm.$store.dispatch("updateLoading", false);
          })
          .catch((error) => {
            vm.$store.dispatch("updateLoading", false);
            this.$notify({
              message: error.response.data.ErrorMessage,
              type: "error",
            });
          });
      }
    },

    delRoom() {
      const vm  = this;
      vm.$api.InterviewSch.deleteRoom(vm.roomModal.Guid)
          .then((response) => {
            if (response.data.ErrorMessage) {
              this.$notify({
                message: response.data.ErrorMessage,
                type: "error",
              });
            } else {
              $("#delModal").modal("hide");
              vm.$notify({
                message: response.data.Data,
                type: "success",
              });
              vm.getRoomList();
            }
            vm.$store.dispatch("updateLoading", false);
          })
          .catch((error) => {
            vm.$store.dispatch("updateLoading", false);
            this.$notify({
              message: error.response.data.ErrorMessage,
              type: "error",
            });
          });
    },

    getRoomList() {
      const vm = this;
      vm.$api.InterviewSch.getRoomList()
        .then((response) => {
          if (response.data.ErrorMessage) {
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            vm.roomList = response.data.Data;
          }
        })
        .catch((error) => {
          this.$notify({
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },
    getRoomDetail() {},

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },
  },

  computed: {
    ...mapGetters(["lang"]),
    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  filters: {
    moment: function (date) {
      if (date === null) {
        return null;
      } else {
        return moment(date).format("YYYY-MM-DD HH:mm");
      }
    },
  },

  created() {
    this.getRoomList();
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  },
};
</script>
